import { Model } from '@descomplica/dex-models';
import { DiscussionModel } from './DiscussionModel';

export interface ChannelInfo {
  id: number;
  name: string;
  slug: string;
}

export class ChannelModel extends Model {
  id: number;

  name: string;

  slug: string;

  constructor(channel: ChannelInfo, getters: unknown) {
    super(getters);
    this.id = channel.id;
    this.name = channel.name;
    this.slug = channel.slug;
  }

  get discussions(): DiscussionModel[] {
    return this.getters.discussionsByChannelId(this.id);
  }

  get discussionCount(): number {
    return this.discussions?.length || 0;
  }

  get uniqueParticipantIdList(): number[] {
    const commentsDepth = 2;
    const userIdList = (this.discussions || [])
      .map((discussion) => {
        const userIdListFromComments = discussion.comments.map((comment) => comment.userId);
        return [discussion.userId, userIdListFromComments];
      })
      .flat(commentsDepth);

    const distinctUserIdSet = new Set(userIdList);

    return Array.from(distinctUserIdSet);
  }

  get participantCount(): number {
    return this.uniqueParticipantIdList.length;
  }
}
